var _a;
export var isIE = ((_a = window) === null || _a === void 0 ? void 0 : _a.ActiveXObject) || 'ActiveXObject' in window;
export var getFileUtil = function getFileUtil(file) {
  var name = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
  if (file) {
    if (isIE) {
      var blob = new Blob([file], {
        type: file.type
      });
      blob.fileName = name || file.name;
      blob.lastModifiedDate = (file === null || file === void 0 ? void 0 : file.lastModifiedDate) || Date.now();
      return blob;
    } else {
      return new File([file], name || file.name, {
        type: file.type
      });
    }
  }
  return file;
};